export const ExternalUrls = {
    BLOG_URL: 'https://join.bambee.com/blog',
    CAREERS_URL: 'https://join.bambee.com/careers',
    HELP_URL: 'https://join.bambee.com/help'
} as const;
